import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { TransferRequestDto } from '../model/dto/TransferRequestDto';
import { TransferRequest } from '../model/TransferRequest';

@Injectable()
export class TransferRequestFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    PostTransferRequest(request: TransferRequestDto): Observable<RequestResponse<number>> {
        return this._httpClient.post<RequestResponse<number>>(this._urlBase + 'api/TransferRequest/Corporate', request);
    }

    PostTransferRequestByOrganization(request: TransferRequestDto): Observable<RequestResponse<number>> {
        return this._httpClient.post<RequestResponse<number>>(this._urlBase + 'api/TransferRequest/Corporate/ByOrganization', request);
    }


    GetAllTransferRequest(): Observable<RequestResponse<TransferRequest[]>> {
        return this._httpClient.get<RequestResponse<TransferRequest[]>>(this._urlBase + 'api/TransferRequest/All');
    }

    GetAllTransferRequestOrganizations(organizations: string): Observable<RequestResponse<TransferRequest[]>> {
        return this._httpClient.get<RequestResponse<TransferRequest[]>>(this._urlBase + 'api/TransferRequest/AllByOrganizations?organizations=' + organizations);
    }

    GetCollectionTransferRequestByDates(organizations: string, starDate: string, endDate: string, language: boolean):
        Observable<RequestResponse<TransferRequest[]>> {
            return this._httpClient.get<RequestResponse<TransferRequest[]>>(this._urlBase
                 + 'api/TransferRequest/AllByOrganizationsDates?organizations='
                 + organizations + '&startDate=' + starDate + '&endDate=' + endDate + '&language=' + language);
        }

    GetTransferRequestSummary(request): Observable<RequestResponse<TransferRequest>> {
        return this._httpClient.get<RequestResponse<TransferRequest>>(this._urlBase
            + 'api/TransferRequest/Summary?transferReqId=' + request);
    }

    GetWeek(): Observable<RequestResponse<any>> {
        return this._httpClient.get<RequestResponse<any>>(this._urlBase
            + 'api/TransferRequest/Week');
    }

    GetWeekByOrganizations(organizations: string): Observable<RequestResponse<TransferRequestDto[]>> {
        return this._httpClient.get<RequestResponse<TransferRequestDto[]>>(this._urlBase
            + 'api/TransferRequest/WeekByOrganizations?organizations=' + organizations);
    }

    DeleteTransferRequest(request): Observable<RequestResponse<boolean>> {
        return this._httpClient.delete<RequestResponse<boolean>>(this._urlBase + 'api/TransferRequest?transferReqId=' + request);
    }

    PostValidateTransferRequest(request: TransferRequestDto): Observable<RequestResponse<any>> {
        return this._httpClient.post<RequestResponse<any>>(this._urlBase + 'api/TransferRequest/CorporateValidate', request);
    }

    /** @deprecated Use PostValidateStores + PostValidateStylesBatch instead */
    PostDataValidationTransferRequest(request: TransferRequestDto): Observable<RequestResponse<TransferRequestDto>> {
        return this._httpClient.post<RequestResponse<TransferRequestDto>>(this._urlBase + 'api/TransferRequest/DataValidation', request);
    }

    /** @deprecated Use PostPreValidateDuplicatesBatch instead */
    PostPreValidateDuplicates(request: TransferRequestDto): Observable<RequestResponse<any[]>> {
        return this._httpClient.post<RequestResponse<any[]>>(this._urlBase + 'api/TransferRequest/Corporate/PreValidateDuplicates', request);
    }

    PostValidateStores(request: TransferRequestDto): Observable<RequestResponse<TransferRequestDto>> {
        return this._httpClient.post<RequestResponse<TransferRequestDto>>(this._urlBase + 'api/TransferRequest/Corporate/ValidateStores', request);
    }

    PostValidateStylesBatch(request: TransferRequestDto): Observable<RequestResponse<TransferRequestDto>> {
        return this._httpClient.post<RequestResponse<TransferRequestDto>>(this._urlBase + 'api/TransferRequest/Corporate/ValidateStyles', request);
    }

    PostPreValidateDuplicatesBatch(request: TransferRequestDto): Observable<RequestResponse<any[]>> {
        return this._httpClient.post<RequestResponse<any[]>>(this._urlBase + 'api/TransferRequest/Corporate/PreValidateDuplicatesBatch', request);
    }

    PostDeactivateTask(taskId: number): Observable<RequestResponse<any>> {
        return this._httpClient.post<RequestResponse<any>>(this._urlBase + 'api/TransferRequest/Corporate/DeactivateTask', { taskId });
    }
}
